import { Component, ChangeDetectionStrategy, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CategoryModel } from "@core/models/categories";
import { GetProductsQuery, ProductReturnModel, WishlistModel } from "@core/services/api.service";
import { LoadProductsAction } from "@ngxs-store/product-store/product.actions";
import { ProductState } from "@ngxs-store/product-store/product.state";
import { StoreSearchTextAction } from "@ngxs-store/search-store/search.actions";
import { WishListState } from "@ngxs-store/wish-list-store/wish-list.state";
import { Select, Store } from "@ngxs/store";
import { Observable, Subscription } from "rxjs";

@Component({
    selector: 'app-product-list-page',
    template: `
        <app-product-list
            [isLoading]="isLoading$ | async"
            [pageNumber]="pageNumber"
            [resultsPerPage]="resultsPerPage"
            [sortBy]="sortBy"
            [sortByDirection]="sortByDirection"
            [brands]="brands$ | async"
            [products]="ProductReturnModel$ | async"
            [wishlist]="wishlist$ | async"
            [productsCategories]="ProductsCategories$ | async"
        ></app-product-list>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListPageComponent implements OnInit, OnDestroy {
    @Select(ProductState.getProductsResult) ProductReturnModel$: Observable<ProductReturnModel>;
    @Select(ProductState.getBrands) brands$: Observable<ProductReturnModel[]>;
    @Select(WishListState.getItems) wishlist$: Observable<WishlistModel>;
    @Select(ProductState.getProductsCategoriesResult) ProductsCategories$: Observable<CategoryModel[]>;
    @Select(ProductState.isLoading) isLoading$: Observable<boolean>;

    category = '';
    brand = '';
    subCategory = '';
    subCategory3 = '';
    subCategory4 = '';
    pageNumber = 1;
    resultsPerPage = 16;
    sortBy = 'Default';
    sortByDirection = 'DESC';
    searchText = '';
    routeSub: Subscription;
    constructor(private store: Store, private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.routeSub = this.activatedRoute.queryParams.subscribe((params) => {
            this.mapQueryParameters(params);
            this.getProducts();
        });
    }

    mapQueryParameters(params) {
        this.category = params.category;
        this.brand = params.brand;
        this.subCategory = params.subCategory;
        this.subCategory3 = params.subCategory3;
        this.subCategory4 = params.subCategory4;
        this.pageNumber = (!params.pageNumber || (this.resultsPerPage !== params.resultsPerPage && params.resultsPerPage)) ? 1 : params.pageNumber;
        this.resultsPerPage = params.resultsPerPage ?? 16;
        this.sortBy = params.sortBy ?? 'Default';
        this.sortByDirection = params.sortByDirection ?? 'DESC';
        this.searchText = params.searchText;
        if (params.searchText) {
            this.store.dispatch(new StoreSearchTextAction({ text: this.searchText }));
        }
    }

    getProducts() {
        const query = new GetProductsQuery({
            pageNumber: this.pageNumber,
            resultsPerPage: this.resultsPerPage,
            sortBy: this.sortBy === 'Default' ? 'Price' : this.sortBy,
            sortDirection: this.sortByDirection,
            descriptionFilter: this.searchText,
            brandFilter: this.brand ? this.brand : null,
            categoryFilter: this.category?.toLowerCase().includes('featured') || this.category?.toLowerCase().includes('home') ? null : this.category,
            subCategory1Filter: this.subCategory ? this.subCategory : null,
            subCategory2Filter: this.subCategory3 ? this.subCategory3 : null,
            subCategory3Filter: this.subCategory4 ? this.subCategory4 : null,
            featuredProductsOnly: this.category?.toLowerCase().includes('featured'),
            newProductsOnly: this.category?.toLowerCase().includes('home'),
            inStockOnly: false
        });
        this.store.dispatch(new LoadProductsAction({ loadProductsQuery: query, updateFilters: true }));
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}
